import React from "react";
import StatusGenerator from "../StatusGenerator/StatusGenerator";
import SAEDLOGO from "../../Assets/Logo/logo.png"
import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography
} from "@mui/material";

const PrintLayout = ({data}) => {

  const headers = [
    "Partner Name",
    "State",
    // "Email Address",
    "Phone Number",
    "Total Loan Granted",
    // "Total Number of Loan Beneficiaries",
    "Website",
    "Status",
  ];

  return (
    <>
      <Grid container direction="column" display={"none"} >
        <Grid item xs direction={"column"} container alignContent={"center"}>
          <Grid item>
            <img src={SAEDLOGO} alt="SAED Logo" height={60} />
          </Grid>
          <div style={{"fontSize": 20}}>
            <b> NYSC </b>
            <b> SAED </b>
          </div>
        </Grid>
        <Grid item xs container justifyContent={"center"} sx={{paddingBottom: "30px"}}>
          <Typography sx={{"fontSize": 24, "fontWeight": "bold"}} >List of Partners</Typography>
        </Grid>
        <Grid>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((header) => (
                  <TableCell key={header} sx={{
                    fontWeight: "bold",
                    fontSize: 17,
                  }}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.name}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.state.stateName}</TableCell>
                  {/* <TableCell>{row.email}</TableCell> */}
                  <TableCell>{row.phoneNumber}</TableCell>
                  <TableCell>{row.totalLoanGranted}</TableCell>
                  {/* <TableCell>{row.totalLoanBeneficiaries}</TableCell> */}
                  <TableCell>{row.website}</TableCell>
                  <TableCell>
                    <StatusGenerator
                      statusText={row.isActive ? "Active" : "Inactive"}
                      variant={row.isActive ? "greenFilled" : "redFilled"}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
        <Grid container direction="column" alignContent="center" sx={{paddingTop: 10, fontSize: "smaller"}}>
          <Grid item xs>
            <Typography>Plot 416, Tigris Cresent Off Aguiyi Ironsi Street, Maitama.PMB 138, Garki ,Abuja.</Typography>
          </Grid>
          <Grid item xs>
            <Typography>Email: info@nysc.gov.ng</Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PrintLayout;
